// This is just an example,
// so you can safely delete all default props below

export default {
    back: 'Tilbake',
    create: 'Opprett',
    new: 'Opprett ny bruker',
    user: 'Bruker',
    delete: 'Slett',
    given_name: 'Fornavn',
    family_name: 'Etternavn',
    email: 'Epost',
    save: 'Lagre',
    confirm_delete: 'Bekreft sletting'
}